package org.example.project.settings

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
@Composable
fun LumaticaInfoField(
    title: String,
    value: String
) {
    Div({
        style {
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            gap(6.px)
            padding(6.px, 8.px)
            backgroundColor(Color.transparent)
            borderRadius(8.px)
            border(1.px, LineStyle.Solid, Color("rgba(255,255,255,0.06)"))
            flex("1 1 auto")
            minWidth(0.px)
        }
    }) {
        Span({
            style {
                color(Color("rgba(255,255,255,0.58)"))
                fontSize(11.px)
                fontWeight("500")
                flexShrink(0)
            }
        }) {
            Text(title)
        }

        Span({
            style {
                color(Color.white)
                fontSize(15.px)
                fontWeight("700")
                property("margin-left", "auto")
                overflow("hidden")
                property("text-overflow", "ellipsis")
                property("white-space", "nowrap")
            }
        }) {
            Text(value.ifBlank { "-" })
        }
    }
}

